export default __webpack_public_path__ + "static/how_3-c83a77f092bf00684bd8545053845239.svg";